import { Form } from "antd";
import type { Rule } from "antd/es/form";
import type { SelectProps } from "antd";
import type { ReactNode } from "react";
import CustomInput from "sipli-fleet-core/components/CustomSharedInput/CustomSharedInput";
import CustomSelect from "sipli-fleet-core/components/CustomSharedSelect/CustomSharedSelect";
import { cn } from "../../../../sipli-fleet-core/utils/cn";

interface CustomerFormFieldProps {
  name: string;
  label: ReactNode;
  placeholder?: string;
  required?: boolean;
  type?: string;
  options?: Array<{ label: string; value: string | number }>;
  loading?: boolean;
  showSearch?: boolean;
  onChange?: SelectProps["onChange"];
  rules?: Rule[];
  className?: string;
  formClassName?: string;
  disabled?: boolean;
}

const CustomerFormField = ({
  name,
  label,
  placeholder,
  required = false,
  type = "text",
  options,
  loading = false,
  showSearch = true,
  onChange,
  rules,
  className,
  formClassName,
  disabled,
}: CustomerFormFieldProps) => (
  <Form.Item
    name={name}
    label={label}
    rules={rules ?? (required ? [{ required: true }] : undefined)}
    className={cn("!mb-3 customer-form-item", formClassName)}
  >
    {options ? (
      <CustomSelect
        options={options}
        placeholder={placeholder}
        className={className || "!h-[28px]"}
        loading={loading}
        showSearch={showSearch}
        onChange={onChange}
        disabled={disabled}
        filterOption={(input, option) =>
          String(option?.label ?? "")
            .toLowerCase()
            .includes(input.toLowerCase())
        }
      />
    ) : (
      <CustomInput
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        className={`!m-0 !h-[28px] !px-2 !py-0 ${className}`}
      />
    )}
  </Form.Item>
);

export default CustomerFormField;
